module.exports = __webpack_public_path__ + "static/media/template.6cb2b705.PNG";